<template>
    <v-container>
      <v-row>
          <v-col cols="12">
            <div class="text-left" style="margin-bottom:20px;">
                <router-link to="/">
                    <v-btn
                        color="secondary"
                        class="text-right"
                        style="width:250px"
                    >
                        Back
                    </v-btn>
                </router-link>
              </div>                  
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h1>No Doubt at the sphere</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:-100px;">
            May 12, 2026, Sydney to Las Vegas
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:20px;">
            May 13, 2026 - No Doubt at the sphere
          </div>
        </v-col>
      </v-row>                    
      <v-row>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:20px;">
            <a href="https://www.nodoubt.com/" target="_blank">
              <v-btn
                color="primary"
                class="text-right"
                style="width:500px; margin-top:15px;"
              >
                No Doubt Official Website
              </v-btn>
            </a>
          </div>
        </v-col>
      </v-row>
      <div class="text-left">Las Vegas to Sydney May 17, 2026</div>
      <div class="text-left">Arrive Sydney May 19, 2026</div>

    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'NoDoubtVegas',
    setup() {
    }
  }
  </script>
